import React, {useEffect} from 'react';
import {logPageLoadEvents, sendEvarData} from '@ibibo/analytics';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import DocUpload from './containers/DocUpload';
import {useSelector, useDispatch} from 'react-redux';
import {
  userDataSelector,
  prevPageNameSelector,
  mpnfoSelector,
  userCountrySelector,
} from '../../store/selectors';
import {updatePreviousPageName} from '../../store/actions';

const DocumentUpload = () => {
  const userInfo = useSelector(userDataSelector);
  const userCountry = useSelector(userCountrySelector);
  const {email, mobile, requestIp, accountId} = userInfo;
  const data = useSelector(prevPageNameSelector);
  const mpnfoValue = useSelector(mpnfoSelector);
  const {prevPageName} = data;
  const dispatch = useDispatch();

  useEffect(() => {
    sendEvarData(
      {
        evar15: 'onboarding:businessKycDetails|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        evar24: 'onboarding|mypartner',
        prop27: '/agent/agencykyc/',
        evar37: userCountry
          ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
          : 'domain_sbu:mypartner|domain_country:in|domain_currency:inr|domain_language:eng',
      },
      true,
    );
    const events = {
      // eVar34: email,
      eVar35: mobile,
      eVar23: prevPageName,
      eVar28: requestIp,
      eVar67: accountId,
      eVar24: 'onboarding|mypartner',
      eVar37: 'domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng',
      eVar107: `mpnfo_${mpnfoValue}`,
    };
    logPageLoadEvents('onboarding:businessKycDetails', events);
    dispatch(updatePreviousPageName('onboarding:businessKycDetails'));
  }, [dispatch]);

  return (
    <OnboardingNew step={2}>
      <DocUpload />
    </OnboardingNew>
  );
};

export default DocumentUpload;
